import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona con adolescentes rebeldes?',
    a: 'Sí, porque se basa en reducir la demanda, que es lo que más rechazan a esa edad.'
  }, {
    q: '¿Tengo que comprar cosas caras?',
    a: 'No, los rituales usan lo que ya tienes en casa.'
  }, {
    q: '¿Qué pasa si mi ex intenta boicotear el momento?',
    a: 'El manual incluye una sección específica para blindar tu tiempo de estos ataques.'
  }, {
    q: '¿Es difícil de aplicar?',
    a: 'Son acciones de menos de 10 minutos; está diseñado para hombres con poco tiempo.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-brand-cream" data-id="element-23">
      <div className="max-w-2xl mx-auto" data-id="element-24">
        <FadeIn data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-26">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-27">
            {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-28" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-lg shadow-sm border border-brand-amber/10 overflow-hidden" data-id="element-29">
      <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-30">
        <span className="font-bold text-lg text-brand-brown" data-id="element-31">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-brand-amber" data-id="element-32" /> : <ChevronDown className="w-5 h-5 text-brand-amber" data-id="element-33" />}
      </button>
      {isOpen && <div className="px-6 pb-4 text-brand-gray/80 text-lg" data-id="element-34">{answer}</div>}
    </div>;
}